import {Form, FormInstance, Select} from 'antd'
import React from 'react'
import {useIntl} from 'react-intl'

export type PlantFormDropdownProps = {
  plantsList?: {id: number; name: string}[]
  currentPlant?: {id: number; name: string}
  fieldName?: string
}

export function plantFormPlantToOption(plant, isCurrent) {
  return {
    label: plant.name,
    value: String(plant.id),
    disabled: isCurrent,
  }
}

export function PlantFormDropdown({
  plantsList,
  currentPlant,
  fieldName = 'todoPlants',
}: PlantFormDropdownProps) {
  const intl = useIntl()

  return (
    <Form.Item name={fieldName} label={intl.formatMessage({id: 'plant'})}>
      {/* {currentPlant ? (
        <Select
          disabled
          mode="tags"
          options={[
            {
              label: currentPlant.name,
              value: currentPlant.id,
            },
          ]}
        ></Select>
      ) : ( */}
      <Select
        allowClear={!currentPlant}
        mode="multiple"
        options={plantsList?.map((plant) =>
          plantFormPlantToOption(plant, currentPlant && plant.id === currentPlant.id)
        )}
        filterOption={(search, option) =>
          (option?.label ?? '').toLowerCase().includes(search.toLowerCase())
        }
      ></Select>
      {/* )} */}
    </Form.Item>
  )
}
